import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdatePrestacionModalidadSectorialByID = () => {
  const [loadingUpdatePrestacionModalidadSectorialById, setLoadingCreatePrestacionModalidadSectorial] = useState(false);
  const [successUpdatePrestacionModalidadSectorialById, setSuccessCreatePrestacionModalidadSectorial] = useState(false);
  const [errorUpdatePrestacionModalidadSectorialById, setErrorCreatePrestacionModalidadSectorial] = useState(null);
  const [dataUpdatePrestacionModalidadSectorialById, setDataPrestacionModalidadSectorial] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // UPDATE
  const updatePrestacionModalidadSectorialById = async (
    userId: string,
    formId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreatePrestacionModalidadSectorial(true);
    setSuccessCreatePrestacionModalidadSectorial(false);
    setErrorCreatePrestacionModalidadSectorial(null);

   
    apiRecord.updateSolicitudModalidadSectorialByID(userId, formId, data)
      .then((res: any) => {
        setLoadingCreatePrestacionModalidadSectorial(false);
        setSuccessCreatePrestacionModalidadSectorial(true);
        setDataPrestacionModalidadSectorial(res.data);

        if (typeof _cb === "function") {
          _cb(res.data);
        }
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingCreatePrestacionModalidadSectorial(false);
        setErrorCreatePrestacionModalidadSectorial(err.response?.data);
      });
  };

  return {
    updatePrestacionModalidadSectorialById,
    loadingUpdatePrestacionModalidadSectorialById,
    successUpdatePrestacionModalidadSectorialById,
    errorUpdatePrestacionModalidadSectorialById,
    dataUpdatePrestacionModalidadSectorialById
  };
};

export default useUpdatePrestacionModalidadSectorialByID;
